import { useTranslation } from "react-i18next";

import { LanguageWarning } from "@components/LanguageWarning";

export const AutoTranslatedWarning = () => {
  const { t } = useTranslation();

  return (
    <LanguageWarning
      labelText={t("AutoTranslatedWarning.label")}
      message={t("AutoTranslatedWarning.message")}
      pillAriaLabel={t("AutoTranslatedWarning.languagePillAriaLabel")}
      changeLanguageText={t("AutoTranslatedWarning.changeLanguage")}
      dropdownId="auto-translated-language-menu"
      testId="auto-translated-warning"
    />
  );
};
